import script from "./DataSecureDescriptionComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataSecureDescriptionComponent.vue?vue&type=script&setup=true&lang=ts"

import "./DataSecureDescriptionComponent.vue?vue&type=style&index=0&id=3b927a9c&lang=css"

const __exports__ = script;

export default __exports__